import { Component, Inject, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';

import { DomSanitizer, SafeUrl } from '@angular/platform-browser';


import { AudioCaptureService } from '../services/audio-capture.service';


import { GestockService } from '../services/gestock.service';
import { padStart } from '../utils/string.utils';


//declare var MediaRecorder: any;

@Component({
  selector: 'app-audio-description-dialog',
  templateUrl: './audio-description-dialog.component.html',
  styleUrls: ['./audio-description-dialog.component.css']
})
export class AudioDescriptionDialogComponent {

  product : any ;

  samacaabiyoonwii : any ;

  //mediaRecorder: MediaRecorder | null = null; 
  
  audioChunks: Blob[] = [];

  audioUrl: SafeUrl | null = null;

  audioUrlBrut : string ;

  recording: boolean = false;
  startTime: number = 0;
  duration: string = '00:00';
  timer: any;

  base64Audio : any ;

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
  spinnerDialogRef : any ;
  etatreq = "" ;

  retourClientWS : any ;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AudioDescriptionDialogComponent>,
    private sanitizer: DomSanitizer,
      private audioService: AudioCaptureService,
          private configServer: GestockService,
                         public dialog: MatDialog ) {
    this.audioUrl = this.sanitizer.bypassSecurityTrustUrl(data.product.audioUrl);
    this.audioUrlBrut = data.product.audioUrl || '';
    this.product = data.product ;
  }


  ngOnInit(){
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;    
  }


  async startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      await this.audioService.startRecording();     

      this.audioService.onstop = (audioBlob: Blob) => {
        //const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
        const unsafeUrl = URL.createObjectURL(audioBlob);
        this.audioUrl = this.sanitizer.bypassSecurityTrustUrl(unsafeUrl);
        this.audioUrlBrut = unsafeUrl ;

        // ✅ Convertir le Blob en base64
        const reader = new FileReader();
        reader.onloadend = () => {
          this.base64Audio = reader.result as string; // "data:audio/webm;base64,..."
        };

        reader.readAsDataURL(audioBlob); // Lancement de la conversion

      };

      this.recording = true;
      this.startTime = Date.now();

      this.timer = setInterval(() => {
        const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
        const minutes = padStart(String(Math.floor(elapsed / 60)), 2, '0');
        const seconds = padStart(String(elapsed % 60), 2, '0');
        this.duration = `${minutes}:${seconds}`;
      }, 1000);
    } catch (error) {
      console.error('Erreur lors de l’accès au microphone', error);
    }
  }

  stopRecording() {
    if (this.audioService) {
      this.audioService.stopRecording();
      this.recording = false;
      clearInterval(this.timer);
    }
  }

//sendWakhJiCiKaw


  mettreAjourImageUrlArticleBi(){
    let infoToUpdt = "wakhdji" ;
    let newValue =  this.audioUrlBrut ;//changingThisBreaksApplicationSecurity ;
    let idarticle = this.product.id ;
    let detailsarticle = this.product.detailsarticle ;

    this.openSpinnerDialog() ;
    this.configServer.mettreAjourDetailsArticleBi(this.samacaabiyoonwii, idarticle, infoToUpdt, newValue, detailsarticle).then( (retourbi) => {
      this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;

      if(statutreq==1){
        this.etatreq='successful' ;
        console.log("Mbirr Yi Matna") ;
      }
      else{
        this.etatreq='failed' ;
        console.log("Failed") ;
      }
    }) ;    
  }

  saveAudioRemotlymob(){
    console.log(this.base64Audio) ;
    this.openSpinnerDialog() ;
    this.configServer.sendWakhJiCiKaw( this.base64Audio ).then( (retourbi) => {
      this.closeSpinnerDialog();
      this.retourClientWS = retourbi ;  
      console.log(this.retourClientWS) ; ;
      if(this.retourClientWS.statutreq==1){
        this.audioUrlBrut = this.retourClientWS.data ;
        this.mettreAjourImageUrlArticleBi() ;
      }
    }) ;
  }

  save() {
    this.dialogRef.close({ audioUrl: this.audioUrlBrut });
  }

  cancel() {
    this.dialogRef.close();
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }

  close(){
    this.dialogRef.close();    
  }


}
